module.exports = __webpack_public_path__ + "img/svg/position-2.e0ea9d068c09b4433171c74d6f00606c.svg";